/**
 * gmailLogin.js
 * Written by: Alex Kasemir
 */

import { authenticateGmail } from '../authenticateGmail';
import event from '../../../../utils/event';

export const GMAIL_LOGIN_START = `GMAIL_LOGIN_START`;
export const GMAIL_LOGIN_SUCCESS = `GMAIL_LOGIN_SUCCESS`;
export const GMAIL_LOGIN_FAILURE = `GMAIL_LOGIN_FAILURE`;

export const gmailLoginStart = () => ({
  type: GMAIL_LOGIN_START,
});

export const gmailLoginSuccess = () => ({
  type: GMAIL_LOGIN_SUCCESS,
});

export const gmailLoginFailure = (error) => ({
  type: GMAIL_LOGIN_FAILURE,
  error,
});

/**
 * Description of the gmailLogin action
 */
export const gmailLogin = (location) => {
  return async (dispatch) => {
    event(`google-init`, [`click`, `google-init`, location]);
    const auth2 = window.gapi.auth2.getAuthInstance();
    try {
      const response = await auth2.signIn({ fetch_basic_profile: true });
      const authResponse = response.getAuthResponse();
      dispatch(gmailLoginSuccess());
      await dispatch(authenticateGmail(authResponse.access_token));
    } catch (e) {
      event(`auth-failure`, [`auth`, `google-failure`, `${e.error}`]);
      dispatch(gmailLoginFailure(e));
    }
  };
};
